<div [ngClass]="{ 'bottom-spacer': isUpliftPage }">
  <footer class="container-fluid footer">
    <app-footer-extended
      *ngIf="!isFlowPage"
      [cmsCopy]="cmsCopy"
      [culture]="culture"
      [navCopy]="navCopy"
    ></app-footer-extended>
  </footer>
</div>

